// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sitemap-page[data-v-65cbbc4d] {\n  width: 910px;\n}\n.slide-move[data-v-65cbbc4d] {\n  transition: transform 0.5s ease-out;\n}\n", ""]);
// Exports
module.exports = exports;
